import { useMatches } from '@tanstack/react-router'
import type { PropsWithChildren } from 'react'
import { SideNav } from '#lib/ui/navigation/side-nav/side-nav'

const NUMBER_OF_ITEMS = {
  ACCOUNT_LAYOUT: 3,
  BRANCH_LAYOUT: 10,
  PERSONAL_LAYOUT: 3,
}

export function SidenavPageLayoutSkeleton({
  numberOfItems,
  children,
}: PropsWithChildren<{
  numberOfItems?: number
}>) {
  const matches = useMatches()

  const isAccountLayout = matches.some(
    m => m.routeId === '/_dashboard/$account',
  )
  const isBranchLayout = matches.some(
    m => m.routeId === '/_dashboard/$account/graphql/$graph/branches/$branch',
  )
  const isPersonalLayout = matches.some(
    m => m.routeId === '/_dashboard/_personal',
  )

  let defaultNumberOfItems = 3
  if (isAccountLayout) {
    defaultNumberOfItems = NUMBER_OF_ITEMS.ACCOUNT_LAYOUT
  }
  if (isBranchLayout) {
    defaultNumberOfItems = NUMBER_OF_ITEMS.BRANCH_LAYOUT
  }
  if (isPersonalLayout) {
    defaultNumberOfItems = NUMBER_OF_ITEMS.PERSONAL_LAYOUT
  }

  return (
    <SideNav.Root content={children}>
      <SideNav.Group>
        {Array.from({ length: numberOfItems ?? defaultNumberOfItems }).map(
          (_, index) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: only used for skeleton
            <SideNav.ItemSkeleton key={index} />
          ),
        )}
      </SideNav.Group>
    </SideNav.Root>
  )
}
